import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

@Injectable({ providedIn: 'root' })
export class GtmService {
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  pushEvent(data: Record<string, any>): void {
    if (!this.isBrowser) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}